import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useFormik } from "formik";
import * as Yup from "yup";

import { editBranchRequest } from '../../../store/Branches/actions'
import { ROUTE_PATHS } from '../../../utils/RoutesPaths';
import messages from '../../../assets/locale/messages';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import Input from "../../../components/Input";

const PublishRequestCard = ({
    branchName,
    branchId,
    branchLocation,
    providerName
}) => {

    const dispatch = useDispatch();
    const lang = useSelector((state) => state.locale.lang);
    const { publishRequests, shared } = messages[lang];
    const [showRejectRequestModal, setShowRejectRequestModal] = useState(false);

    const {values,
           handleSubmit,
           setFieldTouched,
           setFieldValue,
           touched, 
           errors
          } = useFormik({
        initialValues: {reason: ""},
        validationSchema: Yup.object({
            reason: Yup.string().required('Required')
        }),
        onSubmit:async ({reason}) => {
            dispatch(editBranchRequest({
                id:branchId,
                data:{
                    rejection_reasons_attributes:[{reason}],
                    status: 'unpublished'
                } })        
            );
            setShowRejectRequestModal(false);
        }
    })

    const handleCloseRejectRequestModal = () => {
        setShowRejectRequestModal(false)
    }

    const handleConfirmRejectRequest = () => {
        handleSubmit();
    }
    const renderRejectRequestModelContent = () => (
            <form onSubmit={handleSubmit}> 
                <Input
                    id="reason"
                    name="reason"
                    type="text"
                    label={publishRequests.rejectModal.contentText}
                    placeholder={publishRequests.rejectModal.placeholder}
                    required
                    value={values["reason"]}
                    onChange={(value) => {
                        setFieldTouched("reason");
                        setFieldValue("reason", value);
                      }}
                    labelClassName="text-dark font-medium mb-2"
                    isInputHasErr={!!(touched["reason"] && errors["reason"])}
                    errMsg={errors["reason"]}
                />
            </form>
    );

    const handleAcceptPublishRequest = () => {
        dispatch(editBranchRequest({
            id:branchId,
            data:{
                status: 'active'
            } })        
        );
    }

    return(
        <div className='bg-white rounded-4 p-4 mb-3'>
            <div className='fsize-20 fweight-700 mb-3'>
                <Link
                    to={ROUTE_PATHS.viewPublishRequest.replace(':id',branchId)}>
                    {branchName}
                </Link>
            </div>
            <div className='fsize-16 fweight-400'>
                <div className='mb-2 d-flex gap-1'>
                    <span className='text-secondary'><LocationOnOutlinedIcon/></span>
                    {branchLocation}
                </div>
                <div className='d-flex justify-content-between'>
                    <div className='mb-2 d-flex gap-1'>
                        <span className='text-secondary'><PersonOutlineOutlinedIcon/></span>
                        {providerName}
                    </div>
                    <div className='d-flex justify-content-end w-20 gap-2'>
                        <Button
                            onClick={() => {setShowRejectRequestModal(true)}}
                            outlined
                            label={publishRequests.card.rejectLabel}
                            className="w-40"
                            btnStyle="secondary"
                            labelClass="fsize-15 fweight-400 text-secondary"
                        />
                        <Button
                            onClick={() => {handleAcceptPublishRequest()}}
                            label={publishRequests.card.acceptLabel}
                            className="w-40"
                            btnStyle="secondary"
                            labelClass="fsize-15 fweight-400 text-white"
                        />
                    </div>
                </div>
            </div>
            <Modal
                open={showRejectRequestModal}
                handleClose={handleCloseRejectRequestModal}
                title={publishRequests.rejectModal.title}
                contentClass="mb-5 pb-2 text-primary"
                content={renderRejectRequestModelContent()}
                confirmBtnTxt={shared.confirm}
                maxWidth="xs"
                cancelBtnTxt={shared.cancel}
                isContentText={false}
                handleConfirm={handleConfirmRejectRequest}
                handleCancel={handleCloseRejectRequestModal}
                modalClass="delete-services-modal"
                actionsClass="container px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
                cancelBtnClass="fsize-14 py-2 text-secondary"
                disableActionBtn={!!(!touched["reason"] || errors["reason"])}
            />
        </div>
    )
};
export default PublishRequestCard;